import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: "nis-selection-indicator",
  templateUrl: "./selection-indicator.component.html",
})
export class SelectionIndicatorComponent {
  @Input() selected: boolean = false;
}
